import { static_items, static_workLevel } from '../constants';

export const masterSelectionOptions = [
  {
    key: 'static',
    text: 'Static',
    value: 'static',
  },
  {
    key: 'dynamic',
    text: 'Dynamic',
    value: 'dynamic',
  },
];
export const staticOptions = [
  {
    key: 'items',
    text: 'Items',
    value: static_items,
  },
  {
    key: 'worklevel',
    text: 'Worklevel',
    value: static_workLevel,
  },
];
export const criteriaOptions = [
  {
    key: 'equals',
    text: 'equals',
    value: 'equals',
  },
  {
    key: 'not equals',
    text: 'not equals',
    value: 'not equals',
  },
  {
    key: 'greater than',
    text: 'greater than',
    value: 'greater than',
  },
  {
    key: 'less than',
    text: 'less than',
    value: 'less than',
  },
  {
    key: 'greater than or equal to',
    text: 'greater than or equal to',
    value: 'greater than or equal to',
  },
  {
    key: 'less than or equal to',
    text: 'less than or equal to',
    value: 'less than or equal to',
  },
];
